// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

export const Disclaimer: FC = () => {
  const { t } = useTranslation();

  return (
    <footer
      className="bg-sidebar-bg-start px-24 py-4 text-center text-white"
      data-testid="disclaimer"
    >
      <h6 className="text-xs font-semibold">
        {t('glossary.disclaimer', { ns: 'glossary' })}
      </h6>
      <p className="text-[9px]">
        {t('glossary.no-warranties', { ns: 'glossary' })}
      </p>
      <p className="text-[9px]">
        {t('glossary.no-financial-advice', { ns: 'glossary' })}
      </p>
    </footer>
  );
};
